var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"close-btn",class:{
    'close-btn_black': !_vm.isCloseButtonWhite,
    'close-btn_white': _vm.isCloseButtonWhite,
  },on:{"click":_vm.onCloseBannerFunc}},[_c('div',{staticClass:"close-btn__img"})])}
var staticRenderFns = []

export { render, staticRenderFns }